import React from 'react';
import Tag from './Tag';

const ENTITY_COLORS = {
  PERSON: 'bg-blue-100 text-blue-800',
  ORGANIZATION: 'bg-green-100 text-green-800',
  DATE: 'bg-purple-100 text-purple-800',
  COMMERCIAL_ITEM: 'bg-orange-100 text-orange-800',
  QUANTITY: 'bg-teal-100 text-teal-800'
};

const Entities = ({ entities }) => {
  if (!entities || entities.length === 0) {
    return <p className="text-sm text-gray-500">No entities detected.</p>;
  }

  const groups = {};
  entities.forEach(e => {
    if (e && e.Name && e.Values) {
      groups[e.Name] = e.Values;
      return;
    }
    const type = e.Type || e.type || e.name || e.Name || 'OTHER';
    const text = e.Text || e.text || e.value || e;
    if (!groups[type]) groups[type] = [];
    groups[type].push(text);
  });

  const types = Object.keys(groups).filter(t => Object.keys(ENTITY_COLORS).includes(t));

  return (
    <div className="space-y-4">
      {types.map(type => (
        <div key={type}>
          <h4 className="text-sm font-medium text-gray-700 mb-1">{type}</h4>
          <div className="flex flex-wrap gap-2">
            {groups[type].map((val, idx) => (
              <Tag key={idx} className={ENTITY_COLORS[type]}>{val}</Tag>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Entities;
